module.exports = __webpack_public_path__ + "static/media/twitter.0207f4f7.svg";